export const REPEAT_TYPES = {
  DISABLE: "disable",
  WORKFLOW: "workflow",
  STEP: "step",
};
